import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn';
import './StatusDot.css';

export type StatusDotTone = 'live' | 'brand' | 'neutral' | 'coral' | 'success';

export interface StatusDotProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: StatusDotTone;
  /** Brilho + pulso de "ao vivo" (ex.: "Atualização em tempo real", "Aberto"). */
  live?: boolean;
  /** Rótulo opcional ao lado do dot. */
  label?: ReactNode;
}

/**
 * Indicador de status. O motivo de marca: dot âmbar com brilho (`live`) para
 * indicadores em tempo real. Sem `label`, marque com aria-label no uso.
 */
export function StatusDot({
  tone = 'live',
  live = false,
  label,
  className,
  ...rest
}: StatusDotProps): JSX.Element {
  return (
    <span className={cn('cf-statusdot', `cf-statusdot--${tone}`, className)} {...rest}>
      <span
        className={cn('cf-statusdot__dot', live && 'cf-statusdot__dot--live')}
        aria-hidden="true"
      />
      {label != null && <span className="cf-statusdot__label">{label}</span>}
    </span>
  );
}
